import service from '@/utils/server';

const modName='/md/deviceGroup/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const exportData = data => {
  return service({
    url: modName + 'export',
    method: 'post',
    data
  });
};

export const getDeviceGroupAttribute = data => {
  return service({
    url: modName + 'getDeviceGroupAttribute',
    method: 'post',
    data
  });
};

export const getDeviceGroupDetail = data => {
  return service({
    url: modName + 'getDeviceGroupDetail',
    method: 'post',
    data
  });
};

export const updateDeviceGroupAttributeValue = data => {
  return service({
    url: modName + 'updateDeviceGroupAttributeValue',
    method: 'post',
    data
  });
};






// WEBPACK FOOTER //
// ./src/page/md/deviceGroup/api/index.js